import React, { useState } from 'react';

const promisedSetState = (newState) => new Promise(resolve => this.setState(newState, resolve));

const SUPPRESS_ERROR_MESSAGES = true;

class SettingSystem {
    constructor() {
        this.settings = {}
    }

    register(key, getter, onChange) {
        if (!SUPPRESS_ERROR_MESSAGES && this.settings[key] != null) {
            console.log(`Key ${key} has been registered before.`);
        }

        this.settings[key] = {
            getter: getter,
            onChange: onChange,
        }
    }

    registerMember(key, owner, member) {
        this.register(
            key,
            ()=>{
                return owner[member]
            },
            (value)=>{
                owner[member] = value;
            }
        );
    }

    registerState(key, owner, stateName) {
        this.register(
            key,
            ()=>{
                return owner.state[stateName]
            },
            (value)=>{
                return owner.promisedSetState({stateName: value});
            }
        );
    }

    async setSetting(key, value, user) {
        await this.settings[key].onChange(value);
        user.setState({}); // force update
    }

    getSetting(key) {
        // console.log(key, this.settings[key].getter());
        return this.settings[key].getter();
    }
}

export default new SettingSystem();